export const ApiErrorCodes = {
  ALREADY_ENTERED: '7001',
  ALREADY_USED_NICKNAME: '7002',
} as const;
